import React, { useMemo } from 'react'
import TextField from '@material-ui/core/TextField'
import { useField } from 'formik'
import { useTranslation } from 'react-i18next'
import { ErrorMessage } from 'components/Shared/ErrorMessage'
import { isFieldRequired } from 'components/Shared/FormikForm'
import { useValidationSchema } from 'context/validationSchema'

export function NumberField ({
  fieldName,
  label,
  endAdornment,
  endAdornmentValue,
  className,
  required,
  disabled
}) {
  const { schema } = useValidationSchema()

  const [field, meta] = useField(fieldName)
  const { error, touched } = meta
  const { t } = useTranslation()

  const isRequired = useMemo(() => isFieldRequired(schema, fieldName), [schema, fieldName])

  return (
    <TextField
      error={!!error && touched}
      name={fieldName}
      key={fieldName}
      label={t(label)}
      type="number"
      variant="filled"
      required={required === undefined ? isRequired : required}
      helperText={<ErrorMessage name={fieldName}/>}
      className={className || ''}
      min="0"
      disabled={disabled}
      InputProps={{
        disableUnderline: true,
        inputProps: {
          min: 0
        },
        endAdornment: endAdornment ? endAdornmentValue : null
      }}
      {...field}
    />
  )
}
